import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './mainImageStyles';
import MainPic from 'core/components/ContentfulImage';
import Drag, { DragContainer } from './dragSlidesHoc';
import {
	Frame,
} from './mainImageStyles';
import { ResponsiveCheck } from 'core/providers/Responsive';

import {
	isImage as isImg,
} from 'core/utils';

import MainVideo from './mainVideo';

const MainImageWrapper = ({
	ratio, horizontal,
	media, activeSlide,
	videoIsPlaying, dismissVideo,
	videoTrigger,
	listingName,
}) => (
	<ResponsiveCheck>
		{({ isDesktop }) => (
			<Wrapper ratio={ratio} >
				<Drag noWrapper horizontalCallback={horizontal}>
					{({ behaviorProps, dragRef }) => (
						<DragContainer {...behaviorProps} ref={dragRef}>
							{media && media.map(({ url, name, isImage }, id) => {
								const isPic = isImage || isImg(url);
								const isIn = activeSlide === id;
								return (
									<Frame key={id} timeout={500} unmountOnExit in={isIn} ratio={ratio} >
										{isPic ? (
											<MainPic
												src={url} alt={name || `${listingName} Photo ${id + 1}`}
												title={name || `${listingName} Photo ${id + 1}`}
												width={isDesktop ? "590" : "345"}
												height={isDesktop ? "390" : "230"}
											/>
										) : (
											<MainVideo
												url={url}
												name={name}
												id={id}
												dismissVideo={dismissVideo}
												videoIsPlaying={videoIsPlaying}
												videoTrigger={videoTrigger}
											/>
										)}
									</Frame>
								);
							})}
						</DragContainer>
					)}
				</Drag>
			</Wrapper>
		)}
	</ResponsiveCheck>
);

MainImageWrapper.propTypes = {
	media: PropTypes.arrayOf(PropTypes.shape({
		url: PropTypes.string.isRequired,
		name: PropTypes.string,
		isImage: PropTypes.bool,
	})).isRequired,
	activeSlide: PropTypes.number.isRequired,
	dismissVideo: PropTypes.func,
	videoIsPlaying: PropTypes.bool,
	ratio: PropTypes.string,
	isDesktop: PropTypes.bool,
	horizontal: PropTypes.func,
	videoTrigger: PropTypes.func,
	listingName: PropTypes.string,
};

export default MainImageWrapper;
